import { FileStatus } from './files.model';

// Global types
export type Nullable<T> = T | null;
export type Optional<T> = T | undefined;
export type Nullish<T> = T | null | undefined;

export type Char = string;
export type Id = number;

export type Timer = ReturnType<typeof setTimeout>;
export type DateTime = Date;

export enum ServerStatus {
  ok = "ok",
  nok = "nok",
  error = "error",
  done = "done",
}

export interface ServerResponse {
  status: ServerStatus;
  statusCode?: HttpStatusCode;
  code?: number | string;
  message: string;
  view?: string;
  headers?: { [key: string]: string };

  [key: string]: any;
}

export enum SortDirection {
  asc = "asc",
  desc = "desc",
}

export interface IOverviewPayload {
  q: string;
  sort: string;
  sortDirection: SortDirection;
  offset: number;
  limit: number;
  includeDeleted?: boolean;
  includeInactive?: boolean;
}

export interface IFilesOverviewPayload extends IOverviewPayload {
  status?: FileStatus[];
  onlyBackfill?: boolean;
}

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  notModified = 304,
  temporaryRedirect = 307,
  permanentRedirect = 308,
  badRequest = 400,
  notAuthenticated = 401,
  paymentRequired = 402,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  gone = 410,
  preConditionFailed = 412,
  requestTooLarge = 413,
  tooManyRequests = 429,
  internalError = 500,
  notImplemented = 501,
  serviceUnavailable = 503,
}

export const EmptyHttpStatusCodes: Readonly<HttpStatusCode[]> = [
  HttpStatusCode.noContent,
  HttpStatusCode.notModified,
  HttpStatusCode.temporaryRedirect,
  HttpStatusCode.permanentRedirect,
];

export const OkHttpStatusCodes: Readonly<HttpStatusCode[]> = [
  HttpStatusCode.ok,
  HttpStatusCode.created,
  ...EmptyHttpStatusCodes,
];

export const ErrorServerStatuses: Readonly<ServerStatus[]> = [
  ServerStatus.nok,
  ServerStatus.error,
];

export class ServerError extends Error {
  status: number | string;
  statusText: string;
  response?: ServerResponse;
  constructor(
    message: string,
    status: number | string,
    response?: ServerResponse,
  ) {
    super(message);
    this.status = status;
    this.statusText = message;
    this.response = response;
  }
}
